import { ChapterBeat } from ".";
import { v4 as uuid } from "uuid";

/**A Chapter represents each literal chapter in a Story. Each chapter is comprised of a title and a list of blocks of content called ChapterBeats, 
 * which handle the actual assets and their types. */
export interface Chapter {
    title: string
    subtitle?: string
    index: number
    chapterBeats: ChapterBeat[]
}

export function generateIds(chapter: Chapter) {
    chapter.chapterBeats.forEach(beat => {
        beat.beatId = uuid();
    });
}